function checkUrl(): string {
  const clientUrl = `${window.location.protocol}//${window.location.host}`;
  return String(clientUrl);
}

export const serverUrl: string = checkUrl();
export const pollInterval = 5000;
